
/* OC Robotervermietung: Bitte die Kontaktdaten unten vor dem Livegang ersetzen. */
const OC_CONFIG = {
  whatsappNumber: (document.body.dataset.whatsappNumber || "").replace(/\D/g, ""),
  phoneNumber: document.body.dataset.phoneNumber || "",
  displayPhone: document.body.dataset.phoneNumber || "Telefonnummer ergänzen",
  displayWhatsApp: document.body.dataset.whatsappNumber || "WhatsApp-Kontakt ergänzen"
};
const navToggle = document.querySelector(".menu-toggle");
const nav = document.querySelector(".nav");
if (navToggle && nav) {
  navToggle.addEventListener("click", () => {
    const open = nav.classList.toggle("open");
    navToggle.setAttribute("aria-expanded", String(open));
    navToggle.textContent = open ? "×" : "☰";
  });
  nav.querySelectorAll("a").forEach(a => a.addEventListener("click", () => {
    nav.classList.remove("open");
    navToggle.setAttribute("aria-expanded", "false");
    navToggle.textContent = "☰";
  }));
}
document.getElementById("year").textContent = new Date().getFullYear();

function isConfigured(value) {
  return value && !value.includes("XXXXXXXXXX") && value.replace(/\D/g, "").length >= 8;
}
document.querySelectorAll('[data-contact="whatsapp"]').forEach(link => {
  if (isConfigured(OC_CONFIG.whatsappNumber)) {
    link.href = `https://wa.me/${OC_CONFIG.whatsappNumber}?text=${encodeURIComponent("Hallo OC Robotervermietung, ich möchte gerne einen Roboter für mein Event mieten. Können Sie mir bitte Informationen zu Verfügbarkeit und Preis schicken? Vielen Dank!")}`;
    link.target = "_blank"; link.rel = "noopener noreferrer";
  } else {
    link.href = "#anfrage";
    link.addEventListener("click", () => {
      const status = document.getElementById("form-status");
      if (status) status.textContent = "Bitte ergänze deine WhatsApp-Nummer in den Shopify-Theme-Einstellungen.";
    });
  }
});
document.querySelectorAll('[data-contact="phone"]').forEach(link => {
  if (isConfigured(OC_CONFIG.phoneNumber)) {
    link.href = `tel:${OC_CONFIG.phoneNumber.replace(/[^\d+]/g, "")}`;
  } else {
    link.href = "#anfrage";
    link.addEventListener("click", () => {
      const status = document.getElementById("form-status");
      if (status) status.textContent = "Bitte ergänze deine Telefonnummer in den Shopify-Theme-Einstellungen.";
    });
  }
});

const form = document.getElementById("inquiry-form");
form.addEventListener("submit", (event) => {
  event.preventDefault();
  const status = document.getElementById("form-status");
  if (!form.reportValidity()) return;
  if (!isConfigured(OC_CONFIG.whatsappNumber)) {
    status.textContent = "Das Anfrageformular ist bereit. Bitte trage vor dem Livegang deine WhatsApp-Nummer in den Shopify-Theme-Einstellungen ein.";
    return;
  }
  const data = new FormData(form);
  const lines = [
    "Hallo OC Robotervermietung, ich interessiere mich für eine Robotervermietung.",
    "",
    `Name: ${data.get("name")}`,
    `E-Mail: ${data.get("email")}`,
    `Telefon: ${data.get("phone") || "Nicht angegeben"}`,
    `Event: ${data.get("eventType")}`,
    `Gewünschte Dauer: ${data.get("duration")}`,
    `Datum: ${data.get("date") || "Noch offen"}`,
    `Ort: ${data.get("location")}`,
    `Details: ${data.get("details") || "Keine weiteren Angaben"}`,
    "",
    "Bitte teilt mir Verfügbarkeit und Preis mit. Vielen Dank!"
  ];
  const url = `https://wa.me/${OC_CONFIG.whatsappNumber}?text=${encodeURIComponent(lines.join("\n"))}`;
  window.open(url, "_blank", "noopener,noreferrer");
  status.textContent = "WhatsApp wurde geöffnet. Prüfe deine Nachricht und sende sie dort ab.";
});

